import { render, staticRenderFns } from "./ConfigModule.vue?vue&type=template&id=68080d6c"
import script from "./ConfigModule.vue?vue&type=script&lang=js"
export * from "./ConfigModule.vue?vue&type=script&lang=js"
import style0 from "./ConfigModule.vue?vue&type=style&index=0&id=68080d6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports